export default "__VITE_ASSET__DkZQdnOf__"